<template>
  <InPlayerVideoOverlay>
    <OverlayContent>
      <TitleMessage slot="title" />
      <OverlayButton
        slot="content"
        :tracker="getAnalyticPayload(e => e.player['overlay-age-pin-gate'].click.action, video.id)"
        @click="performAction({
          fn: openPinModal,
          tracker: {
            label: 'enter-pin',
          },
        })"
      >
        {{ $t('enter-pin') }}
      </OverlayButton>
    </OverlayContent>
  </InPlayerVideoOverlay>
</template>

<script lang="ts">
import { getAnalyticPayload } from '@/scripts/libs/analytic';
import { VideoPlayerOverlayBase } from '../layout/VideoPlayerOverlayBase';
import InPlayerVideoOverlay from '../layout/InPlayerVideoOverlay.vue';
import OverlayContent from '../components/OverlayContent.ts.vue';
import OverlayButton from '../components/OverlayButton.ts.vue';
import TitleMessage from './AgeRestrictedOverlay/TitleMessage.ts.vue';
import EnterPinModal from '../components/EnterPinModal.ts.vue';

export default VideoPlayerOverlayBase.extend({
  i18n: {
    en: {
      'enter-pin': 'Enter PIN to watch',
    },
    zh: {
      'enter-pin': '登錄觀看',
    },
    id: {
      'enter-pin': 'Masukan PIN untuk menonton',
    },
  },
  computed: {

  },
  components: {
    TitleMessage,
    InPlayerVideoOverlay,
    OverlayContent,
    OverlayButton,
  },
  methods: {
    openPinModal(): void {
      this.$modal.show(EnterPinModal, {
        width: '100%',
        maxWidth: 300,
        height: '100%',
        adaptive: true,
      });
    },
    getAnalyticPayload,
  },
});
</script>
